import { createSlice } from '@reduxjs/toolkit';

const PRELOADER_DURATION_MS = 2000;

const preloaderSlice = createSlice({
  name: 'preloader',
  initialState: {
    isLoading: false,
  },
  reducers: {
    setPreloaderLoading: (state, action) => {
      state.isLoading = action.payload;
    },
  },
});

const { setPreloaderLoading } = preloaderSlice.actions;

export const startPreloader = () => (dispatch) => {
  dispatch(setPreloaderLoading(true));

  setTimeout(() => {
    dispatch(setPreloaderLoading(false));
  }, PRELOADER_DURATION_MS);
};

export default preloaderSlice.reducer;
